export const USER_TOKEN = 'USER_TOKEN'
export const USER_INFO = 'USER_INFO'